import React from "react";

export const getBeam = (beams, channelBeamName) => {
    for (var i = 0; i < beams.length; i++) {
        if (beams[i].name.includes(channelBeamName)) {            
            if (beams[i].downlink != "undefined") {
                return beams[i]
            }
        }
    }
}

export const coordinatesFormater = (mapPolygons) => {
    let beamCoordinate = [];
    if (mapPolygons != "undefined") {
        for (let j = 0; j < mapPolygons.length; j++) {
            beamCoordinate[j] = JSON.parse(mapPolygons[j].coordinates);
        }
    }
    return beamCoordinate;
}

export const getPowersLevelWithCoord = (mapPolygons, beamCoordinate) => {
    var mapPowerLevelWithCoordinates = new Map();
    if (mapPolygons != "undefined") {
        for (let j = 0; j < mapPolygons.length; j++) {
            mapPowerLevelWithCoordinates.set(beamCoordinate[j][0], JSON.parse(mapPolygons[j].powerLevel));
        }
    }
    return mapPowerLevelWithCoordinates;
}